import React from 'react'
import { AuthorSC } from './author.styled'
import avatar from '../../../assets/avatar.png'

const Author: React.FC = () => (
  <AuthorSC>
    <img src={avatar} alt='avatar' />
  </AuthorSC>
)

export default Author
